import { render, staticRenderFns } from "./TabAbility.vue?vue&type=template&id=8ae07cae&scoped=true&"
import script from "./TabAbility.vue?vue&type=script&lang=js&"
export * from "./TabAbility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae07cae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae07cae')) {
      api.createRecord('8ae07cae', component.options)
    } else {
      api.reload('8ae07cae', component.options)
    }
    module.hot.accept("./TabAbility.vue?vue&type=template&id=8ae07cae&scoped=true&", function () {
      api.rerender('8ae07cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabAbility.vue"
export default component.exports